import React, { useContext, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Delete from '@material-ui/icons/DeleteOutline';
import { useTranslation } from '../../hooks/useTranslation';
import colors from '../../themes/main-colors';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { NotificationsContext } from '../../providers/NotificationsProvider';
import Backdrop from '../backdrop';
import { IconButton } from '@material-ui/core';
import { useTrustedDevice } from '../../hooks/useTrustedDevice';
import useAccountCustomer from '../../hooks/useAccountCustomer';

type Props = {};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2),
    },
    cardContent: {
      paddingBottom: '16px !important',
    },
    phoneInfo: {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
      },
    },
    deleteMFA: {
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
        marginTop: theme.spacing(2),
      },
    },
    pointer: {
      cursor: 'pointer',
    },
  }),
);

const TrustedDeviceList = ({}: Props) => {
  const { t } = useTranslation();
  const { customer } = useAccountCustomer();

  const notificationContext = useContext(NotificationsContext);

  const {
    isTrustedDevice,
    removeCurrentDeviceFromTrustedList,
  } = useTrustedDevice();

  const classes = useStyles();

  const showNotification = (
    message: string,
    type: 'error' | 'success' = 'success',
  ) => {
    notificationContext.setState({
      isOpen: true,
      message: message,
      severity: type,
    });
    window.scrollTo(0, 0);
  };

  const removeTrustedDevice = () => {
    if (customer?.email) {
      showNotification(t('TWO_STEP_AUTH_TRUSTED_DEVICE_REMOVED'));
      void removeCurrentDeviceFromTrustedList(customer.email);
    }
  };

  if (!customer?.email) {
    return null;
  }

  if (!isTrustedDevice(customer?.email)) {
    return null;
  }

  return (
    <>
      <Card className={classes.container}>
        <CardContent className={classes.cardContent}>
          <Grid container sx={{ px: 2, py: 1 }}>
            <Grid item xs={12} md={12} className={classes.phoneInfo}>
              <Typography css={{ display: 'flex', alignItems: 'center' }}>
                <CheckCircle
                  htmlColor={colors.shoreGreen}
                  fontSize="small"
                  style={{ marginRight: '8px' }}
                />
                {t('TWO_STEP_AUTH_BROWSER_IS_TRUSTED_DEVICE')}
              </Typography>
              <IconButton>
                <Delete
                  htmlColor={colors.midGrey}
                  onClick={() => removeTrustedDevice()}
                  className={classes.pointer}
                  aria-label="delete-icon-btn"
                  role="button"
                />
              </IconButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default TrustedDeviceList;
